var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"five-star-qa"},[_c('van-image',{staticClass:"bg",attrs:{"width":"100%","height":"100%","lazy-load":"","src":_vm.getImgUrl('publicMobile/fivestarqa/qabg.png')}}),_c('div',{staticClass:"btn",on:{"click":_vm.go}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }